import { render } from "./base-allowedaction-group-button.vue?vue&type=template&id=ae3cc2a0&ts=true"
import script from "./base-allowedaction-group-button.vue?vue&type=script&lang=ts"
export * from "./base-allowedaction-group-button.vue?vue&type=script&lang=ts"

import "./base-allowedaction-group-button.vue?vue&type=style&index=0&id=ae3cc2a0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__